<section class="card">
    <div class="cancelado-grid">
        <div>
            <i class="pi pi-calendar-times"></i>
            <h1>Seu pedido foi cancelado...</h1>
            <p>Se precisar, você pode enviar um novo pedido.</p>
            <div class="action-buttons">
                <p-button severity="secondary" (click)="voltarPaginaInicial()">Voltar a página inicial</p-button>
                <p-button (click)="fazerNovoPedido()">Fazer novo pedido</p-button>
            </div>
        </div>
    </div>
</section>